<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Típus"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.type === 1" size="small" type="success">Manuális</el-tag>
      <el-tag v-if="scope.row.type === 2" size="small" type="warning">Automatikus</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'type',
};
</script>
